import React, { FC } from 'react';
import { productDropdown } from '../../../../constants/analytics.constants';
import { iconSize } from '../../../../constants/icon.constants';
import { googleNavClickEvent } from '../../../../utils/analytics';
import Icon from '../../icon';
import RoutableNotEditableLink from '../../routableNotEditableLink';
import { TNavigationBarDropdownDesktop } from '../types/navigationBar.types';

const formTitleUrl = (baseUrl: string, titleUrl: string) => {
  const urlArr = baseUrl.split('/');
  urlArr.pop();
  urlArr.push(titleUrl);
  return urlArr.join('/');
};
const NavigationBarDropdownDesktop: FC<TNavigationBarDropdownDesktop> = (props): JSX.Element => {
  const { handleClick, title, contextItemUrl, dropDownSeriesData, dropdownIsOpen, handleDropDown } = props;
  return (
    <div
      className={`navigation-bar-container__dropdown ${dropDownSeriesData && dropDownSeriesData?.length > 1 ? 'navigation-bar-container__dropdown--cursor-pointer' : ''
        }`}
    >
      <span
        className="navigation-bar-container__dropdown-content"
        role="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleClick();
        }}>
        <span className="navigation-bar-container__dropdown-data" title={title}>
          {title}
        </span>
        {dropDownSeriesData && dropDownSeriesData?.length > 1 && (
          <Icon
            iconName={dropdownIsOpen ? "arrow-chevron-up" : "arrow-chevron-down"}
            size={iconSize.dsk}
            color="primary"
            extraClassName={`navigation-bar-container__dropdown-icon ${dropdownIsOpen ? 'navigation-bar-container__dropdown-icon--is-open' : ''
              }`}
          />
        )}
      </span>
      {dropdownIsOpen && (
        <ul className="navigation-bar-container__dropdown-list">
          {dropDownSeriesData?.map((dropDownData) =>
            dropDownData.title !== null && dropDownData.title !== '' ? (
              <li
                className="navigation-bar-container__dropdown-list-item"
                key={dropDownData?.title}
                onClick={(): void => {
                  handleDropDown();
                  googleNavClickEvent(
                    productDropdown,
                    formTitleUrl(contextItemUrl || '', dropDownData?.titleUrl || ''),
                    dropDownData?.title
                  );
                }}
              >
                <RoutableNotEditableLink
                  href={formTitleUrl(contextItemUrl || '', dropDownData?.titleUrl || '')}
                  className="navigation-bar-container__dropdown--contents--link"
                >
                  {dropDownData?.title}
                </RoutableNotEditableLink>
              </li>
            ) : null
          )}
        </ul>
      )}
    </div>
  );
};

export default NavigationBarDropdownDesktop;
